import { HttpContext, HttpContextToken } from '@angular/common/http';

/** Marks a request whose error response is handled by the caller instead of showing the global error toast. */
export const SKIP_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);

/** Builds an `HttpContext` that opts a request out of the global error toast. */
export function skipErrorHandlerContext(): HttpContext {
	return new HttpContext().set(SKIP_ERROR_HANDLER, true);
}
